export interface CurrencyOption {
  code: string;
  symbol: string;
  label: string;
}

export const currencies: CurrencyOption[] = [
  {
    code: "BAM",
    symbol: "KM",
    label: "Bosnian Mark",
  },
  {
    code: "EUR",
    symbol: "€",
    label: "Euro",
  },
  {
    code: "USD",
    symbol: "$",
    label: "US Dollar",
  },
  {
    code: "RSD",
    symbol: "дин",
    label: "Serbian Dinar",
  },
  {
    code: "HRK",
    symbol: "kn",
    label: "Croatian Kuna",
  },
];
